export type GoogleVoicePreviewLanguage = 'English' | 'Norwegian';

const normalizeLanguageCode = (languageCode: string) => languageCode.trim().replace(/_/g, '-').toLowerCase();

export const resolveGoogleVoicePreviewLanguage = (languageCode: string): GoogleVoicePreviewLanguage => {
  const normalizedLanguageCode = normalizeLanguageCode(languageCode);
  const baseLanguage = normalizedLanguageCode.split('-')[0];

  if (baseLanguage === 'nb' || baseLanguage === 'nn' || baseLanguage === 'no') {
    return 'Norwegian';
  }

  return 'English';
};

export const buildGoogleVoicePreviewUrl = (languageCode: string, voiceId: string) => {
  const normalizedVoiceId = voiceId.trim();
  if (!normalizedVoiceId) return null;

  const previewLanguage = resolveGoogleVoicePreviewLanguage(languageCode);
  return `/audio/google-aivoice/${previewLanguage}/${encodeURIComponent(normalizedVoiceId)}.mp3`;
};
